import api from "@/application";

import {
  GET_EMAILS_REQUEST,
  GET_EMAILS_REQUEST_SUCCESS,
  GET_EMAILS_REQUEST_FAILURE,
  PATCH_EMAILS_REQUEST,
  PATCH_EMAILS_REQUEST_SUCCESS,
  PATCH_EMAILS_REQUEST_FAILURE,
} from "./mutation-types";

const actions = {
  getEmails: async ({ commit, rootGetters }) => {
    commit(GET_EMAILS_REQUEST);

    try {
      const profileId = rootGetters["profile/profileId"];
      const { data } = await api.emailBilling.getEmails(profileId);

      commit(GET_EMAILS_REQUEST_SUCCESS, data);

      return data;
    } catch (e) {
      commit(GET_EMAILS_REQUEST_FAILURE);

      throw new Error(e.response?.data?.errorMessage);
    }
  },

  patchEmails: async ({ commit, rootGetters }, request) => {
    commit(PATCH_EMAILS_REQUEST);

    try {
      const profileId = rootGetters["profile/profileId"];
      const { data } = await api.emailBilling.patchEmails(request, profileId);

      commit(PATCH_EMAILS_REQUEST_SUCCESS, data);

      return data;
    } catch (e) {
      commit(PATCH_EMAILS_REQUEST_FAILURE);

      throw new Error(e.response?.data?.errorMessage);
    }
  },
};

export default actions;
